<div *ngIf="queue.length > 0 || (activeCall && !activeCall.inProgress)" class="queue-toggle-wrapper">
  <div class="queue-toggle" (click)="callDisplayOpen = !callDisplayOpen">
    <span *ngIf="callDisplayOpen; else closed">Hide </span>
    <ng-template #closed>Show </ng-template>
    Queue <span *ngIf="queue.length > 0">({{ queue.length }})</span>
  </div>
</div>

<div *ngIf="!callDisplayOpen && (activeCall || queue.length > 0)" class="queue-bar"></div>

<div @animateIn @animateOut id="call-container" class="mat-elevation-z3" *ngIf="callDisplayOpen">

  <div class="call-display-container tw-flex-wrap">
    <div class="call-inner-display-container tw-w-full" data-cy="call-bar" *ngIf="activeCall">
      <div class="call-display-cell call-display-borrower">
        <p class="call-info">
          <span *ngIf="!activeCall.callId && activeCall.businessName">Up Next...<br /></span>

          <!-- Softphone users Known borrowerId -->
          <a *ngIf="activeCall.borrowerId" [routerLink]="['/borrower/' + activeCall.borrowerId]" class="business-name" [ngClass]="{'participants-display' : additionalParticipantsDisplay}">
            {{ additionalParticipantsDisplay ? (displayBusinessName | truncate: 16) : displayBusinessName }}
              <span *ngIf="additionalParticipantsDisplay" class="participants-display" [matMenuTriggerFor]="participantsMenu">{{ participantsDisplay }}</span>
            <br />
          </a>

          <!-- Softphone users Unknown borrowerId -->
          <a *ngIf="!activeCall.borrowerId" class="business-name" [ngClass]="{'participants-display' : additionalParticipantsDisplay}">
            {{ additionalParticipantsDisplay ? (displayBusinessName | truncate: 16) : displayBusinessName }}
              <span *ngIf="additionalParticipantsDisplay" class="participants-display" [matMenuTriggerFor]="participantsMenu">{{ participantsDisplay }}</span>
            <br />
          </a>

          <mat-menu #participantsMenu="matMenu" class="participant-menu">
            <table mat-table [dataSource]="dataSource">

              <!-- Participant name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef hidden="true"></th>
                <td mat-cell *matCellDef="let participant">
                  <span *ngIf="participant.contactId; else check_for_borrowerId" >{{ participant.contact.first + ' ' + participant.contact.last | truncate: 20 }}</span>
                  <ng-template #check_for_borrowerId>
                    <span *ngIf="participant.borrowerId">{{ participant.borrower.name | truncate: 20 }}</span>
                  </ng-template>
                  <span *ngIf="participant.lenderUserId">{{ participant.lenderUser.user.first + ' ' + participant.lenderUser.user.last | truncate: 20 }}</span>
                  <span *ngIf="!participant.contactId && !participant.borrowerId && !participant.lenderUserId">{{ 'Unknown Participant' }}</span>
                </td>
              </ng-container>

              <!-- Participant mute icon -->
              <ng-container matColumnDef="muteIcon">
                <th mat-header-cell *matHeaderCellDef hidden="true"></th>
                <td mat-cell *matCellDef="let participant">
                  <span *ngIf="participant.lenderUserId && participant.label === 'silentMonitor' && participant.muted == true" class="material-icons call-unmuted participant-menu-mute">mic_off</span>
                </td>
              </ng-container>

              <!-- Participant phone number -->
              <ng-container matColumnDef="phoneNumber">
                <th mat-header-cell *matHeaderCellDef hidden="true"></th>
                <td mat-cell *matCellDef="let participant">
                  <span class="participant-phone-number">{{ (participant.label === 'silentMonitor' ? participant.fromNumber : participant.callerNumber) | phone }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>
          </mat-menu>

          <span *ngIf="activeCall.callId" class="current-phone">{{ displayPhoneNumber | phone }} -
            <span class="call-state" [ngClass]="{ 'on hold': 'text-red', 'dialing': 'text-orange', 'call joined': 'text-green', 'connected': 'text-green', 'canceled': 'text-danger', 'disconnected': 'text-danger', 'error': 'text-danger' }[activeCall.callState]">
              <span *ngIf="!twilioDeviceIsLoading">{{ activeCall.callState | titlecase }}</span>
              <span *ngIf="twilioDeviceIsLoading" class="text-orange">Loading...</span> <!-- This is twilio device state, not call state -->
            </span>
          </span>
        </p>
      </div>
      <div class="call-display-cell call-display-actions">
        <span *ngIf="callIsOnHold; else callIsActive" class="tw-mt-1">
          <span class="material-icons call-holded">phone_paused</span>
          <span class="material-icons call-holded">mic_off</span>
        </span>
        <ng-template #callIsActive>
          <button class="call-mute-mic" *ngIf="(softphoneConnected$ | async) && timerOpen && (silentMonitorInProgress && !canUnmuteSilentMonitorCall)">
            <span class="material-icons call-unmuted">mic_off</span>
          </button>
          <button class="call-mute-mic" *ngIf="(softphoneConnected$ | async) && timerOpen && (!silentMonitorInProgress || (silentMonitorInProgress && canUnmuteSilentMonitorCall))" [disabled]='callStateIsProcessing'>
            <span class="material-icons call-unmuted" *ngIf="isMuted" (click)="handleMute(false)">mic_off</span>
            <span class="material-icons call-muted" *ngIf="!isMuted" (click)="handleMute(true)">mic</span>
          </button>
        </ng-template>
        <span @btnAnimateIn class="call-timer" *ngIf="timerOpen">
          <softphone-timer [activeCall]="activeCall" [callTimers]='callTimers'></softphone-timer>
        </span>
        <div *ngIf="activeCall.borrowerId && (activeCall.callState !=='dialing' || activeCall.callState !=='connected')">

          <!-- Text Btn -->
          <a [routerLink]="['/borrower/' + activeCall.borrowerId]" [queryParams]="{pane: 'messages', subpane: 'sms'}">
            <button
              @btnAnimateIn
              class="call-display-btn mat-elevation-z4 call-display-btn-primary"
              *ngIf="!activeCall.inProgress && !timerOpen"
              mat-flat-button>
              Text
            </button>
          </a>

          <!-- Email Btn -->
          <a [routerLink]="'/borrower/' + activeCall.borrowerId" [queryParams]="{pane: 'messages', subpane: 'email'}">
            <button
              @btnAnimateIn
              class="call-display-btn mat-elevation-z4 call-display-btn-primary"
              *ngIf="!activeCall.inProgress && !timerOpen"
              mat-flat-button>
              Email
            </button>
          </a>

          <!-- Call Btn -->
          <button
            [matMenuTriggerFor]="callBorrower"
            [disabled]="callStateIsProcessing"
            @btnAnimateIn
            *ngIf="!activeCall.inProgress && !timerOpen"
            class="call-display-btn mat-elevation-z4 call-display-btn-primary call-btn-margin"
            mat-flat-button>
            Call <span class="fa fa-caret-down"></span>
          </button>

        </div>
        <mat-menu #callBorrower="matMenu">
          <p class="phone-types-header">Business</p>
          <button
            class="phone-type-btn"
            *ngIf="activeCall.businessPhone && activeCall.businessPhoneCountryCode"
            mat-menu-item
            [disabled]="callStateIsProcessing"
            (click)="handleCall('+' + activeCall.businessPhoneCountryCode + activeCall.businessPhone)">
            {{ activeCall.businessPhoneCountryCode + activeCall.businessPhone | phone }}
          </button>
          <p class="phone-types-header">{{ activeCall.borrower && activeCall.borrower.primaryContact ? activeCall.borrower.primaryContact.first + ' ' + activeCall.borrower.primaryContact.last : 'Primary Contact' }}</p>
          <button
            class="phone-type-btn" *ngIf="activeCall.officePhone && activeCall.officePhoneCountryCode"
            mat-menu-item
            [disabled]="callStateIsProcessing"
            (click)="handleCall('+' + activeCall.officePhoneCountryCode + activeCall.officePhone)">
            Office: {{ activeCall.officePhoneCountryCode + activeCall.officePhone | phone }}
          </button>
          <button
            class="phone-type-btn" *ngIf="activeCall.mobilePhone && activeCall.mobilePhoneCountryCode"
            mat-menu-item
            [disabled]="callStateIsProcessing"
            (click)="handleCall('+' + activeCall.mobilePhoneCountryCode + activeCall.mobilePhone)">
            Mobile: {{ activeCall.mobilePhoneCountryCode + activeCall.mobilePhone | phone }}
          </button>
        </mat-menu>

        <button
          @btnAnimateIn
          data-cy="hang-up-btn"
          class="mat-elevation-z4 call-display-btn-danger"
          id="call-btn-margin"
          *ngIf="displayEndButton"
          mat-mini-fab
          (click)="endCallConfirmation()">
          <mat-icon>call_end</mat-icon>
        </button>
        <button
          @btnAnimateIn
          class="call-display-btn mat-elevation-z4 call-display-btn-danger"
          id="call-btn-margin"
          *ngIf="activeCall.callId && (activeCall.callState === 'connecting' || activeCall.callState === 'dialing')"
          mat-flat-button
          data-cy="cancel-call"
          (click)="handleCancelCall()">
          Cancel
        </button>
        <app-queue-smart></app-queue-smart>

        <!-- softphone menu -->
        <button
          *ngIf="displayEndButton && (softphoneConnected$ | async) && !silentMonitorInProgress"
          mat-mini-fab
          color="transparent"
          #softphoneMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="softphoneMenu"
          class="mat-elevation-z0"
          style="background-color: transparent">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" fill="#02c0ee"/></svg>
        </button>
        <mat-menu #softphoneMenu="matMenu" class="mw-100 call-display" (closed)="softphoneMenuComp.navReset()">
          <app-softphone-menu
            class="w-100"
            #softphoneMenuComp
            [call]="activeCall"
            [alreadyTwoCalls]="cannotAddACall"
            [callStateIsProcessing]="callStateIsProcessing"
            [callIsOnHold]="callIsOnHold"
            (startSecondCall)="handleSecondCall($event)"
            (transferCall)="handleTransferCall($event)"
            (placeCallOnHold)="handleHoldCall($event)"
            (placeCallOffHold)="handleUnHoldCall($event)"
            (click)="$event.stopPropagation()">
          </app-softphone-menu>
        </mat-menu>

      </div>
    </div>
    <app-mid-call-disposition-action
      *ngIf="displayEndButton"
      class="call-optional-disposition tw-w-full"
      [activeCall]="activeCall"
      [callDurationMs]="callDurationMs"
      [teamType]="teamType"
      [midCallDispositionSaved]="midCallDispositionSaved"
      (dispositionCompleted)="handleMidCallDispositionCompleted()">
    </app-mid-call-disposition-action>
  </div>
  <div>
    <app-on-hold-call
      *ngIf="secondaryCall"
      [secondaryCall]="secondaryCall"
      [callStateIsProcessing]="callStateIsProcessing"
      (swapTheCalls)="swapTheCalls()"
      (mergeTheCalls)="mergeTheCalls()"
    >
    </app-on-hold-call>
  </div>
</div>

<div *ngIf="alerts.length">
  <app-alert
    *ngFor="let alert of alerts; let index = i"
    [level]="alert.level"
    [message]="alert.message"
    (dismissed)="handleDismissCallAlert(i)">
  </app-alert>
</div>
